import React from 'react';
import NavbarAccessRestriction from '@organisms/navbar/navbarAccessRestriction';
import ForbiddenAccessModal from '@organisms/modals/forbiddenAccessModal';

const ForbiddenAccess = () => {
  return (
    <>
      <NavbarAccessRestriction />
      <ForbiddenAccessModal />
    </>
  );
};

export default ForbiddenAccess;
